<style src="./ContextMenu.scss" lang="scss"></style>

<template lang="pug">
  .context-menu(
    v-esc='close'
    v-click-outside='close'
    :class='classList'
  )
    button.context-menu__button(
      @click='toggle'
      type='button'
    )
      .context-menu__symbol
        Icon(
          v-if='this.mode === "addToPlaylist"'
          name='add'
        )
        Icon(
          v-else
          name='dots'
        )
      .context-menu__title(
        v-if='title'
      ) {{ title }}

    .context-menu__box(
      v-if='visible'
      ref='box'
    )
      ul.context-menu__list(
        v-if='!submenu'
        ref='list'
      )
        li.context-menu__item(
          v-for='item in list'
          v-if='$accessControl.is(item.accessLevel) || item.authModal'
        )
          button.context-menu__trigger(
            @click.stop='action(item)'
            type='button'
          )
            .context-menu__icon
              Icon(
                :name='item.icon'
              )
            span.context-menu__label {{ item.title }}

      .context-menu__submenu(
        v-if='submenu'
      )
        button.context-menu__subtitle(
          ref='subtitle'
          type='button'
          @click.stop='closeSubmenu'
        ) {{ submenu.title }}
        ul.context-menu__list
          li.context-menu__item(
            @click='action(item)'
            v-for='item in submenu.items'
          )
            button.context-menu__trigger.is-sub(
              type='button'
            )
              .context-menu__icon
                Icon(
                  :name='item.icon'
                )
              span.context-menu__label {{ item.title }}
</template>

<script>
import Icon from "@/components/Icon/Icon";
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    list: Array,
    title: String,
    color: { default: "" },
    mode: { default: "" },
    size: { default: "" }
  },
  data() {
    return {
      visible: false,
      hidden: false,
      side: "right",
      submenu: null
    };
  },
  components: {
    Icon
  },
  computed: {
    ...mapGetters({
      authenticated: "user/authenticated"
    }),
    classList() {
      return {
        "has-title": Boolean(this.title),
        "is-visible": this.visible,
        "is-hidden": this.hidden,
        "is-active": this.hasVisibleItems,
        [`is-${this.side}`]: true,
        ...(this.color ? { [`is-${this.color}`]: this.color } : {}),
        ...(this.mode ? { [`is-${this.mode}`]: this.mode } : {}),
        ...(this.size ? { [`is-${this.size}`]: this.size } : {})
      };
    },
    hasVisibleItems() {
      return this.list.some(
        item =>
          this.$accessControl.is(item.accessLevel) ||
          (!this.authenticated && item.authModal)
      );
    }
  },
  methods: {
    ...mapActions({
      openModal: "modal/open"
    }),
    openSubmenu(item) {
      this.submenu = {
        title: item.title,
        items: item.subitems
      };
      this.$nextTick(() => {
        this.$refs.subtitle.focus();
      });
    },
    closeSubmenu() {
      this.submenu = null;
      this.$nextTick(() => {
        const firstEl = this.$refs.list.querySelector("button, a");
        if (firstEl) {
          firstEl.focus();
        }
      });
    },
    action(item) {
      if (!this.authenticated && item.authModal) {
        this.openModal({ name: "login" });
        this.close();
      } else {
        switch (true) {
          case Boolean(item.subitems):
            this.openSubmenu(item);
            break;
          default:
            item.action();
            this.close();
            break;
        }
      }
    },
    toggle() {
      if (!this.visible) {
        this.checkWindowIntersection();
      }

      this.visible = !this.visible;
    },
    close() {
      this.submenu = null;
      this.visible = false;
    },
    checkWindowIntersection() {
      this.side = "right";
      this.hidden = true;

      setTimeout(() => {
        try {
          const { box } = this.$refs;
          const { x } = box.getBoundingClientRect();

          this.side = x < 0 ? "left" : "right";
        } catch (error) {
          console.error(error);
        } finally {
          this.hidden = false;
        }
      });
    }
  }
};
</script>
